export const APIURL = process.env.REACT_APP_APIURL;
export const SITEURL = process.env.REACT_APP_SITEURL;
export const SCORMURL = process.env.REACT_APP_SCORMURL;
export const ENV_NAME = "academy";

export const LOGIN_FORMS = {
  LOGIN: 0,
  FORGOT_PASSWORD: 1,
  NEW_PASSWORD: 2,
  PRELOGIN : 3,
  PRELOGINEMAIL : 4
};

export const LANGUAGES = {
  Turkish: "tr-TR",
  English: "en-US",
  Arabic: "ar-AE",
  French: "fr-FR",
  German: "de-DE",
  Russian: "ru-RU",
  Spanish: "es-ES",
  Croatian: "hr-HR",
  Italian: "it-IT",
};

export const LANGUAGE_CODES = {
  Turkish: 1055,
  English: 1033,
  Arabic: 14337,
  French: 1036,
  German: 1031,
  Russian: 1049,
  Spanish: 1034,
  Croatian: 1050,
  Italian: 1040,
};

export const ENV = {
  DEV: 0,
  TEST: 1,
  PROD: 2,
};


export const GoogleReCaptcha = {
  SiteKey: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
};
